/**
 * The sides of the drawer layout
 */
export var LvDrawerLayoutSide;
(function (LvDrawerLayoutSide) {
    LvDrawerLayoutSide["Left"] = "left";
    LvDrawerLayoutSide["Right"] = "right";
})(LvDrawerLayoutSide || (LvDrawerLayoutSide = {}));
//# sourceMappingURL=model.js.map